import { axiosAjax } from '@app/src/config/axios';
import { FreeExtrachargeModel } from '@app/src/views/StepOne/form/models/freeExtracharge';
import { hydrateData } from './hydrators';

export const freeExtrachargeService = {
  async get(categoryId: number): Promise<FreeExtrachargeModel[]> {
    try {
      const { data } = await axiosAjax.get(
          process.env.API_FREE_EXTRACHARGE
            .replace(':categoryId', String(categoryId))
        )
      if (data.error) {
        throw new Error();
      }
      return data.data && hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
